module.exports = __webpack_public_path__ + "img/body-3-lg.1c50f28f.png";